// Structural subset of Honeybadger's Notice. Declared here because the full
// type lives in @honeybadger-io/core, which is only a transitive dependency.
interface NoticeWithBacktrace {
  backtrace?: { file?: string }[]
}

const FIRST_PARTY_SCRIPT = /\.(?:js|mjs|ts|vue)$/

function isFirstPartyFrame(file: string | undefined): boolean {
  if (!file) {
    return false
  }

  let url: URL
  try {
    url = new URL(file, window.location.origin)
  } catch {
    return false
  }

  return (
    url.origin === window.location.origin &&
    FIRST_PARTY_SCRIPT.test(url.pathname)
  )
}

// Honeybadger's window.onerror hook captures every error on the page, including
// ones thrown by browser-injected scripts (crypto wallet providers) and tag
// managers. Those are blamed on the HTML document rather than a script file, so
// a notice with frames but none of them ours did not originate in this app.
export default function thirdPartyErrorFilter(
  notice?: NoticeWithBacktrace,
): boolean {
  if (!notice?.backtrace?.length) {
    return true
  }

  return notice.backtrace.some((frame) => isFirstPartyFrame(frame?.file))
}
